import React, { Fragment } from "react"

import PropTypes from "prop-types"

import "./index.less"

import SummaryWidgets from "../SummaryWidgets"
import { Spin } from "antd"
import WidgetQualitativeQuestion from "../WidgetQualitativeQuestion"
import WidgetQualitativeBubbles from "../../../ReportsV2/components/WidgetQualitativeBubbles"
import {
  isAmbassadorActive,
  isAmbassadorOrLeaderActive,
  isLeader,
  isLeaderActive,
} from "../../../utils/storage"
import WidgetResultByDimensionTeam from "./components/WidgetResultByDimensionTeam"
import WidgetResultByTeam from "./components/WidgetResultByTeam"
import WidgetAnalysisSegmentTeam from "./components/WidgetAnalysisSegmentTeam"
import WidgetResultNps from "../WidgetResultNps"
import WidgetMultipleChoiceQuestions from "../WidgetMultipleChoiceQuestions"
import SummaryQuestions from "../SummaryQuestions"
import WidgetResume from "../WidgetResume"
import { get } from "lodash"
import { TYPE_SURVEY } from "../../../utils/constants"
import { validate } from "../../../utils/functions"
import { verifyFeatureFlag } from "../../../utils/feature-flags"

export function LeadershipMeasurement(props) {
  const hasSegment = !validate.empty(props.selectedSegment)

  const renderResultByDimension = () => {
    const {
      typeMeasurement,
      idMeasure,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props

    return (
      <WidgetResultByDimensionTeam
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderResultEnps = () => {
    const { measureGeneral, idMeasure, selectedSegment } = props
    if (!measureGeneral.has_enps) {
      return null
    }
    // return <WidgetLeadershipResultEnps idMeasure={idMeasure} />
    /* return (
      <WidgetChartEnps idMeasure={idMeasure} measureGeneral={measureGeneral} />
    ) */
    // return <WidgetResultEnps idMeasure={idMeasure} />
    return (
      <WidgetResultNps
        idMeasure={idMeasure}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderResultByTeam = () => {
    const {
      typeMeasurement,
      idMeasure,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    return (
      <WidgetResultByTeam
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderSegmentAnalysis = () => {
    const {
      typeMeasurement,
      idMeasure,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props

    if (measureGeneral.segments.length >1  && !verifyFeatureFlag('seg2-5') &&  (selectedSegment === 0 || selectedSegment === null) ){
      return null
    }

    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null) &&
      !isAmbassadorOrLeaderActive() &&
      !isLeaderActive() &&
      measureGeneral.new_version === 0
    ) {
      return null
    }

    let newSelectedSegment = selectedSegment

    if (isLeader() && measureGeneral.segments.length > 0) {
      newSelectedSegment = measureGeneral.segments[0].id_segment
    }

    return (
      <WidgetAnalysisSegmentTeam
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        selectedSegment={newSelectedSegment}
      />
    )
  }

  const renderQualitativeQuestions = () => {
    const {
      typeMeasurement,
      idMeasure,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      isAmbassadorActive() &&
      !measureGeneral.ambassador_qualitative_results_visible
    ) {
      return null
    }
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null) &&
      !isAmbassadorOrLeaderActive() &&
      !isLeaderActive()
    ) {
      return null
    }

    return (
      <WidgetQualitativeQuestion
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderQualitativeBubbles = () => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      isAmbassadorActive() &&
      !measureGeneral.ambassador_qualitative_results_visible
    ) {
      return null
    }
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null) &&
      !isAmbassadorOrLeaderActive() &&
      !isLeaderActive()
    ) {
      return null
    }

    return (
      <WidgetQualitativeBubbles
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderMultipleChoiceQuestions = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null) &&
      !isAmbassadorOrLeaderActive() &&
      !isLeaderActive()
    ) {
      return null
    }

    /* if (!hasSegment) {
      return null
    } */

    return (
      <WidgetMultipleChoiceQuestions
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderSummaryQuestions = () => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null) &&
      !isAmbassadorOrLeaderActive() &&
      !isLeaderActive()
    ) {
      return null
    }

    return (
      <SummaryQuestions
        isLeadership
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
        measureGeneral={props.measureGeneral}
      />
    )
  }

  const renderEvolutionAndResult = () => {
    const {
      measureTotal,
      idDivisionSelected,
      idMeasure,
      measureGeneral,
      idDivisionParent,
      selectedSegment,
    } = props
    const isLeadership = true
    return (
      <WidgetResume
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        className="WidgetResume boxShadow"
        measureData={measureTotal}
        isLeadership={isLeadership}
        selectedSegment={selectedSegment}
        title={
          <Fragment>
            <b>
              {isLeadership
                ? TYPE_SURVEY.leadership.nameSurveyType
                : setNameMetricsTotalLabel()}
            </b>
          </Fragment>
        }
        withEmpty
      />
    )
  }

  const setNameMetricsTotalLabel = () => {
    const { measureGeneral } = props
    let surveyType = get(measureGeneral, "id_survey_type", null)
    let hasLabel = get(measureGeneral, "metric_total_label", null)
    let response = "Clima laboral"
    if (surveyType === 1 && hasLabel !== null) {
      response = get(measureGeneral, "metric_total_label", null)
    }
    return response
  }

  if (props.isLoading) {
    return (
      <div>
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      </div>
    )
  }

  return (
    <div>
      {renderEvolutionAndResult()}
      {renderSummaryQuestions()}
      <SummaryWidgets
        typeMeasurement={props.typeMeasurement}
        idMeasure={props.idMeasure}
        measureTotal={props.measureTotal}
        measureGeneral={props.measureGeneral}
        selectedSegment={props.selectedSegment}
        hasSegment={hasSegment}
      />
      <div style={{ display: "flex" }}>
        {renderResultByDimension()}
        {/* renderResultEnps() */}
      </div>
      {renderResultByTeam()}
      {renderSegmentAnalysis()}
      {props.measureGeneral.sentiment_analysis_version
        ? renderQualitativeBubbles()
        : renderQualitativeQuestions()}
      {renderMultipleChoiceQuestions()}
    </div>
  )
}

LeadershipMeasurement.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  isLoading: PropTypes.bool,
}

export default LeadershipMeasurement
